// extracted by mini-css-extract-plugin
module.exports = {"Item":"Item___3ndLf","RightSide":"RightSide___35pI1","Icon":"Icon___2Kg4X","Title":"Title___2QcUx","Arrow":"Arrow___1CQ3_","loading":"loading___epbI7"};